import { GREY_S } from 'app/constants/Colors';
import { createStyles } from 'app/utils/css';
import React from 'react';

interface IProps {
  checkbox?: React.ReactNode;
}

const CheckboxWithLabel: React.SFC<IProps> = ({ children, checkbox = <input type="checkbox" /> }) => (
  <Styles>{(css) =>
    <label className={css('container')}>
      <div>
        {checkbox}
      </div>

      <div className={css('label')}>
        {children}
      </div>
    </label>
  }</Styles>
);

const Styles = createStyles({
  container: {
    display: 'inline-flex',
    cursor: 'pointer',
    alignItems: 'baseline',
  },
  label: {
    flexGrow: 1,
    color: GREY_S,
    fontSize: '14px',
    paddingLeft: '0.75em',
    textAlign: 'left',
  },
});

export default CheckboxWithLabel;
